import { render, staticRenderFns } from "./AddTradeShowPage.vue?vue&type=template&id=60c3c22a&scoped=true&"
import script from "./AddTradeShowPage.vue?vue&type=script&lang=js&"
export * from "./AddTradeShowPage.vue?vue&type=script&lang=js&"
import style0 from "./AddTradeShowPage.vue?vue&type=style&index=0&id=60c3c22a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c3c22a",
  null
  
)

export default component.exports